import {EventEmitter, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel} from '@microsoft/signalr';

export enum RefreshedDataAction {
	//Use the campaignId as parameter's
	CreateCampaign = "CreateCampaign",
	UpdateCampaign = "UpdateCampaign",
	DeleteCampaign = "DeleteCampaign",
	DuplicateCampaign = "DuplicateCampaign",
	SetFace = "SetFace",
	SetSport = "SetSpot",
	RemoveFace = "RemoveFace",

	//Use the faceId as parameter's
	SetPlaylistOrder = "SetPlaylistOrder",

	//Use the spotId as parameter's
	UpdateSpot = "UpdateSpot",
}

export type RefreshedDataPayload = {
	action: RefreshedDataAction,
	data: any
}

@Injectable({
	providedIn: 'root',
})
export class SignalrService {
	private hubConnection?: HubConnection;
	private token?: string;

	public RefreshedData = new EventEmitter();
	public SpotsProgressionData = new EventEmitter();
	public ImageGenerated = new EventEmitter();

	connect(token?: string) {
		if (!!token && token !== this.token) {
			this.disconnect();
			this.token = token;
		}

		if (!this.token || !!this.hubConnection) {
			return;
		}

		// Configuration de la connexion SignalR
		this.hubConnection = new HubConnectionBuilder()
			.withUrl(environment.apiBaseUrl + '/wanviewhub', {
				skipNegotiation: true,
				transport: HttpTransportType.WebSockets,
				accessTokenFactory: () => {
					return this.token;
				}
			})
			.build();

		// Enregistrement des méthodes écoutées
		this.hubConnection.on('RefreshedData', (data: string) => {
			this.RefreshedData.emit(JSON.parse(data));
		});

		this.hubConnection.on('SpotProgression', (data: string) => {
			this.SpotsProgressionData.emit(data);
		});

		this.hubConnection.on('GenerationFinished', (data: string) => {
			this.ImageGenerated.emit(JSON.parse(data));
		});

		// Connexion au serveur
		this.hubConnection.start().then((data: any) => {
		}).catch((error: any) => {
			setTimeout(() => this.connect(), 5000);
		});

	}

	disconnect() {
		if (!!this.token) {
			this.token = undefined;
		}
		if (!!this.hubConnection) {
			this.hubConnection.stop();
			this.hubConnection = null;
		}
	}
}
